import Content from './content';
import { useTranslations } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import HotspotDescription from './About.styles';
import { type PopupProps, Popup } from '@/components/Popups';

export const About = (props: PopupProps) => {
  const { /* first, second, third, */ image } = useTranslation(Content);

  const [first, second] = useTranslations([
    '05AboutPopupFirstParagraph',
    '05AboutPopupSecondParagraph'
  ]);

  return (
    <Popup {...props} header={<img alt="Golden Getaway" src={image} />}>
      <HotspotDescription>{first}</HotspotDescription>
      <HotspotDescription>{second}</HotspotDescription>
      {/* <HotspotDescription>{third}</HotspotDescription> */}
    </Popup>
  );
};
